import { render, staticRenderFns } from "./clientesEspecificos.vue?vue&type=template&id=2145891b&scoped=true&"
import script from "./clientesEspecificos.vue?vue&type=script&lang=js&"
export * from "./clientesEspecificos.vue?vue&type=script&lang=js&"
import style0 from "./clientesEspecificos.vue?vue&type=style&index=0&id=2145891b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145891b",
  null
  
)

export default component.exports